export const PlayasFotos = [
    {
    id:'1',
    img:require('../Imagenes/Rioplayas/foto1.jpg'),
    Title:'Ciudadela de Machu Pichu'
    
    },
    
    {
        id:'2',
        img:require('../Imagenes/Rioplayas/foto2.jpg'),
        Title:'Ciudadela de Machu Pichu'
        
    },
    
    {
        id:'3',
        img:require('../Imagenes/Rioplayas/foto3.jpg'),
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    {
        id:'4',
        img:require('../Imagenes/Rioplayas/foto4.jpg'),
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    {
        id:'5',
        img:require('../Imagenes/Rioplayas/foto5.jpg'),
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    {
        id:'6',
        img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    {
        id:'7',
        img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    {
        id:'8',
        img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    {
        id:'9',
        img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
        Title:'Ciudadela de Machu Pichu'
       
        
    },
    
    
    
    
    ]